import { Text } from '@oneaudi/unified-web-components';
import { ConfigurationSectionStyle } from '~/app/compositions/content/components/styles/section-style';
import { useI18n } from '~/app/i18n/i18n';

export function SubtotalSection({ subtotal }: { subtotal: string | null | undefined }) {
	const { i18n } = useI18n();

	return (
		<ConfigurationSectionStyle>
			<div className="section-container">
				<div className="title">
					<Text variant={{ type: 'copy', order: '1', style: 'bold' }}>{i18n('ngc.currency.subtotal')}</Text>
				</div>
				<Text variant={{ type: 'copy', order: '1', style: 'normal' }} className={'alignRight'}>
					{subtotal}
				</Text>
			</div>
		</ConfigurationSectionStyle>
	);
}
